// @flow

export default {
  actions: {
    done: 'Fertig',
    duplicate: 'Duplizieren',
    replace: 'Ersetzen',
    back: 'Zurück',
    selectCountry: 'Land auswählen...',
    deleteFile: 'Diese Datei löschen?',
    deleteVoyageCourse: 'Diesen Reiseverlauf löschen?',
    deleteQ: 'Löschen?',
    discard: 'Änderungen verwerfen',
    indent: 'Unterordnen',
    yes: 'Ja',
    save: 'Speichern',
    delete: 'Löschen',
    saveAndBack: 'Speichern & Zurück',
    saveAndPublish: 'Speichern und Veröffentlichen',
    deleteContactPeople: 'Ansprechpartner löschen',
    addContactPeople: 'Ansprechpartner hinzufügen',
    showHistory: 'Historie anzeigen',
    close: 'Schließen',
    add: 'Hinzufügen',
    insert: 'Einfügen',
    no: 'Nein',
    create: 'Erstellen',
    edit: 'Bearbeiten',
    archive: 'Archivieren',
    select: 'Auswählen',
    download: 'Herunterladen',
    show: 'Anzeigen',
    copy: 'Kopieren',
    options: 'Optionen',
    cancel: 'Abbrechen',
    fileUpload: 'Klicken oder Datei hier ablegen',
    searching: 'Suchen',
    searchInProgress: 'Suche...',
    reset: 'Zurücksetzen',
    signOut: 'Abmelden',
    signIn: 'Anmelden',
    createFromVoyage: 'Reiseverlauf für Reise erstellen',
    createVoyageTimeline: 'Reiseverlauf erstellen',
    copyVoyageTimeline: 'Reiseverlauf kopieren',
    replacesMaster: 'Ersetzt Master',
    createAlternateVoyageCourse: 'Abw. Verlauf anlegen',
    createVoyageInfoTemplate: 'Länderinformationsvorlage erstellen'
  },
  misc: {
    entries: 'Einträge',
    content: 'Inhalt'
  },
  uiComponents: {
    table: {
      emptyText: 'Keine Einträge'
    }
  },
  types: {
    file: 'Datei'
  },
  context: {
    voyage: 'Reise',
    voyage_date: 'Termin',
    booking: 'Buchung'
  },
  messages: {
    success: 'Erfolgreich',
    error: 'Fehler',
    saveTimeout:
      'Es ist eine Zeitüberschreitung beim Speichern aufgetreten. Bitte versuchen Sie es in einem Augenblick noch einmal.',
    changesSaved: 'Änderungen wurden gespeichert.',
    savedAndPublished: 'Erfolgreich veröffentlicht',
    draftDiscarded: 'Entwurf wurde zurückgesetzt',
    documentSelectionSuccess: 'Dokumente erfgolreich ausgewählt.',
    documentAlreadyExistsOnVoyage:
      'Dokument existiert bereits für diese Reise.',
    duplicateFileError: 'Diese Datei existiert bereits.',
    selectExistingFile: 'Möchten Sie die existierende Datei auswählen?',
    changesNotSavedTimeline:
      "Änderungen am Reiseverlauf noch nicht gespeichert. Klicken Sie auf 'OK' um die Änderungen zu verwerfen."
  },
  errors: {
    errorGeneral: 'Es ist ein unbekannter Fehler aufgetreten.',
    error404:
      'Anfrage konnte nicht bearbeitet werden. Bitte versuchen Sie es erneut oder Kontaktieren Sie einen Administrator.',
    error401:
      'Ihr Anmeldetoken ist nicht mehr gültig. Bitte melden Sie sich erneut an.'
  },
  voyage_info_template: {
    published: 'veröffentlicht',
    draft: 'Entwurf',
    title: 'Länderinformationen',
    country: 'Land',
    templateInfo: 'Vorlageninformation',
    template: 'Länderinformationenvorlage',
    laenderinfo: 'Länderinformation',
    addAdminModule: 'Baustein hinzufügen', //'Admin-Baustein hinzufügen',
    addPMModule: 'PM-Baustein hinzufügen',
    // addAdminModule: 'Textbaustein hinzufügen',
    // addPMModule: 'Editierbaren-Bereich hinzufügen',
    removeEditableArea: 'Bereich löschen'
  },
  voyage_timeline: {
    copyVoyageCourseToOtherVoyage: 'Reiseverlauf in andere Reise kopieren',
    reiseverlauf: 'Reiseverlauf',
    reiseverlaeufe: 'Reiseverläufe',
    editMaster: 'Master bearbeiten',
    archiveVoyageCourse: 'Reiseverlauf archivieren?',
    deviantVoyageTimelines: 'Abw. Reiseverläufe',
    newVoyageDay: 'Neuer Reisetag',
    newDivider: 'Trenner',
    replaceMasterConfirmTitle:
      'Bitte bestätigen Sie das ersetzen des aktuellen Master-Reiseverlaufs',
    replaceMasterConfirmContent:
      'Dieser Reiseverlauf wird als neuer Master angelegt und ersetzt somit den aktuellen Master. Sind Sie sicher?',
    confirmMasterReplace: 'Master ersetzen',
    archiveError: 'Reiseverlauf konnte nicht archiviert werden.',
    voyageTimelineArchived: 'Reiseverlauf wurde archiviert.'
  },
  document_manager: {
    dokumentAuswaehlen: 'Dokument auswählen',
    bitteMindEineReiseWaehlen: 'Bitte wählen Sie mind. eine Reise aus.',
    dokumentenArt: 'Dokumentenart',
    reisenAusgewaehlt: 'Reisen ausgewählt',
    voyages: {
      detail: {
        optional: 'wird benötigt?',
        notNeeded: 'nicht benötigt'
      },
      table: {
        Master: 'Master',
        Child: 'Kopie',
        selectDocumentType: 'Dokumentenart auswählen...',
        Reise: 'Reise',
        Reisetitel: 'Reisetitel',
        Reisedatum: 'Reisedatum',
        Termine: 'Termine',
        Termin: 'Termin',
        Kunde: 'Kunde',
        TerminBearbeiten: 'Termin bearbeiten',
        Reisevariante: 'Reisevariante',
        AllgemeinerDokumente: 'Allgemeine Dokumente',
        UploadAnEinerReise: 'Upload an einer Reise',
        UploadAnTermin: 'Upload an einem Termin',
        UploadAnBuchung: 'Upload an einer Buchung',
        BuchungTeilnehmer: 'Buchung/Teilnehmer',
        ReiseBearbeiten: 'Reise bearbeiten',
        SucheNachReisetitel: 'Suche nach Reisetitel',
        BuchungBearbeiten: 'Buchung bearbeiten',
        ZuDenTerminen: 'Zu den Terminen',
        ZuDenBuchungen: 'Zu den Buchungen'
      }
    }
  },
  documentModules: {
    title: 'Textbausteine',
    create: 'Textbaustein Erstellen',
    last_minute_unterlagen: 'Last Minute Unterlagen',
    reiseinformationen: 'Reiseinformationen',
    manageCategories: 'Kategorien verwalten',
    category: 'Kategorie',
    country: 'Land',
    createDocument: 'Dokument erstellen',
    editDocument: 'Dokument bearbeiten',
    addDocumentModule: 'Textbaustein hinzufügen',
    replacedDocumentModule: 'Textbaustein wurde ersetzt'
  },
  dateFormats: {
    default: 'DD.MM.YYYY'
  },
  titleInputMap: {
    title1: 'Titel',
    title2: 'Subheadline',
    salutation: 'Anrede',
    description_short: 'Kurzbeschreibung',
    description_long: 'Reisebeschreibung',
    wandern: 'Wandern',
    radfahren: 'Radfahren',
    kanufahren_rafting: 'Kanufahren/Rafting',
    fahrtstrecke: 'Fahrstrecke',
    hotel: 'Unterkunft',
    boardservice: 'Boardservice',
    fruestueck: 'Frühstück',
    mittagessen: 'Mittagessen',
    abendessen: 'Abendessen',
    position: 'Position',
    ort: 'Ort',
    main_contact_people: 'Hauptansprechpartner',
    day: 'Reisetag',
    divider_title: 'Reise-Headline',
    meals: 'Mahlzeiten',
    telefon: 'Telefon',
    mobil: 'Mobil',
    email: 'E-Mail',
    titel: 'Titel',
    nachname: 'Nachname',
    vorname: 'Vorname',
    strasse: 'Straße',
    plz: 'Postleitzahl',
    organisation: 'Organisation',
    status: 'Status',
    country_id: 'Land',
    has_unpublished_changes: 'Status',
    'hotel_attributes[voyage_variation_ids]': 'Favoriten',
    'hotel_attributes[title]': 'Hotelname'
  },
  crudTitles: {
    document_modules_categories: 'Kategorien',
    agency_addresses: 'Agenturen',
    agency_addresses_help: '',
    archiv_agency_addresses: 'Archivierte Agenturen',
    archiv_agency_addresses_help: 'Archivierte Agenturen',
    document_modules: 'Textbausteine',
    document_modules_help: 'Textbausteine',
    hotel_addresses: 'Hotels',
    hotel_addresses_help: '',
    archiv_hotel_addresses: 'Archivierte Hotels',
    archiv_hotel_addresses_help: 'Archivierte Hotels',
    guide_addresses: 'Reiseleiter',
    guide_addresses_help: '',
    archiv_guide_addresses: 'Archivierte Reiseleiter',
    archiv_guide_addresses_help: 'Archivierte Reiseleiter',
    airline_addresses: 'Airlines',
    airline_addresses_help: '',
    archiv_airline_addresses: 'Archivierte Airlines',
    archiv_airline_addresses_help: 'Archivierte Airlines'
  },
  rte: {
    actionToTitle: {
      source: 'Quellcode anzeigen',
      'insert-table': 'Tabelle einfügen',
      'insert-row': 'Zeile einfügen',
      'insert-column': 'Spalte einfügen',
      'remove-table': 'Tabelle löschen',
      'remove-row': 'Zeile löschen',
      'remove-column': 'Spalte löschen',
      placeholder: 'Platzhalter anzeigen',
      'remove-linebreaks': 'Absätze/whitespace entfernen',
      bold: 'Fett',
      italic: 'Kursiv',
      underlined: 'Unterstrichen',
      'heading-one': 'Überschrift 1',
      'heading-two': 'Überschrift 2',
      'heading-three': 'Überschrift 3',
      'numbered-list': 'Geordnete Liste',
      'bulleted-list': 'Ungeordnete Liste',
      'block-quote': 'Zitat'
    }
  },
  voyage_content: {
    stillInDraftMode:
      'Eine abweichende Reisebeschreibung kann erst nach dem Veröffentlichen erstellt werden.',
    editImageSelection: 'Bildauswahl bearbeiten',
    associatedDates: 'zugehörige Termine',
    voyageContents: 'Reisebeschreibungen',
    editBaseInfo: 'Grunddaten bearbeiten',
    editBaseInfoSub: '(z.B. Title, Termine, Preise ...)',
    unassignedDates: 'Nicht zugeordnete Termine',
    unassignedDatesHelp: 'Nicht zugeordnete Termine',
    internalTitle: 'Interner Titel',
    dates: 'Termine',
    updatedAt: 'zuletzt bearbeitet ',
    by: 'von',
    editMaster: 'Master bearbeiten',
    deviantVoyageContent: 'Abweichende Reisebeschreibung',
    status: {
      complete:
        'alle Termine zugeordnet / alle Reisebeschreibungen veröffentlicht',
      incomplete:
        'es existieren unzugeordnete Termine / Reisebeschreibungen im Entwurfsmodus',
      offline: 'Reise im alten Manager offline geschaltet'
    },
    uploadPicture: 'Bild hinzufügen',
    deleteDeviationQuestion:
      'Willst du diese Reisebeschreibung wirklich löschen?',
    deleteDeviationDetail:
      'Alle Inhalte werden gelöscht! Zugeordnete Termine werden wieder den Bereich der unzugeordneten Terminen verschoben.',
    deleteDeviationConfirm: 'Reisebeschreibung löschen',
    deleteDeviationSuccess: 'Reisbeschreibung wurde gelöscht!',
    deleteDeviationFail: 'Reisbeschreibung konnte nicht gelöscht werden!'
  },
  dashboard: {
    voyage_content: {
      title: 'Reiseinformationen in Entwurf-Status',
      helpText:
        'Alle Reiseinformationen die sich noch im Status: Entwurf befinden.'
    }
  },
  months: {
    '1': 'Januar',
    '2': 'Februar',
    '3': 'März',
    '4': 'April',
    '5': 'Mai',
    '6': 'Juni',
    '7': 'Juli',
    '8': 'August',
    '9': 'September',
    '10': 'Oktober',
    '11': 'November',
    '12': 'Dezember'
  }
};



// WEBPACK FOOTER //
// ./src/utils/i18n.js